<template>
    <div class="course-box" style="height: 100%;">
        <div class="base-box">
            <div class="first-line">
                <i class="iconfont icon-jiahao2fill"></i>
                <div>基本信息</div>
            </div>
            <div class="second-line">
                <span style="color: #f56c6c;">*&nbsp;</span>
                <div style="margin-right: 1rem;">课程名称</div>
                <el-input v-model="form.courseName" show-word-limit maxlength="200" :disabled="disabled" @blur="save"
                    style="width: 19rem;" placeholder="请输入课程名称"></el-input>
                <div style="margin-right: 1rem;margin-left: 9rem;">课时</div>
                <div>{{ form.creditHour || 0 }}</div>
            </div>
        </div>
        <div style="height: calc(100% - 12rem);overflow: auto;">
            <div class="third-line">
                <span style="color: #f56c6c;">*&nbsp;</span>
                <div>课程所属分类</div>
                <el-radio-group :disabled="disabled" v-model="form.classifyCode" @input="changeCode">
                    <el-radio v-for="(item, index) in Category" :key="index" :label="item.value">{{ item.label
                        }}</el-radio>
                </el-radio-group>
            </div>
            <div class="course-item" style="margin-top: 2rem;">
                <div class="course-title">课程封面</div>
                <el-upload :disabled="disabled" style="width: 6rem !important; height: 6rem !important" action="#"
                    accept=".jpg,.jpeg,.png" list-type="picture-card" :auto-upload="false" :show-file-list="false"
                    class="upload-box-img" :on-change="handleFm">
                    <img v-if="form.coverImageUrl" :class="{ 'disabled-btn': disabled }"
                        :src="getImgUrl(form.coverImageUrl)"
                        style="width: 5.8rem; height: 5.8rem;object-fit: cover;border-radius: 0.6rem;" />
                    <i v-else class="el-icon-plus"></i>
                </el-upload>
            </div>
            <div class="course-item" style="margin-top: 3rem;">
                <div class="course-title">课程介绍视频</div>
                <upload-chunk :disabled="disabled" ref="chunk" accept=".mp4,.avi,.ts,.flv,.avi,.wmv" @upload="upload"
                    @del_file="upload"></upload-chunk>
            </div>
            <div class="course-item" style="margin-top: 3rem;">
                <div class="course-title">参考标准</div>
                <el-input :disabled="disabled" type="textarea" @blur="save" v-model="form.referenceStandard"
                    placeholder="请输入参考标准"></el-input>
            </div>
            <div class="course-item" style="margin-top: 3rem;">
                <div class="course-title">课程简介</div>
                <el-input v-model="form.courseDescription" :disabled="disabled" @blur="save" type="textarea"
                    placeholder="请输入课程简介"></el-input>
            </div>
            <div class="course-item" style="margin-top: 3rem;">
                <div class="course-title">课程目标</div>
                <el-input v-model="form.courseTarget" :disabled="disabled" @blur="save" type="textarea"
                    placeholder="请输入课程目标"></el-input>
            </div>
            <div class="course-item" style="margin-top: 3rem;">
                <div class="course-title">课程设计</div>
                <el-input v-model="form.courseDesign" :disabled="disabled" @blur="save" type="textarea"
                    placeholder="请输入课程设计"></el-input>
            </div>
            <div class="course-item" style="margin: 3rem 0;">
                <div class="course-title">课程特色</div>
                <el-input v-model="form.courseFeature" :disabled="disabled" @blur="save" type="textarea"
                    placeholder="请输入课程特色"></el-input>
            </div>
        </div>
    </div>
</template>

<script>
import { uploadFile } from '@/assets/js/oss';
import UploadChunk from '../../common/UploadChunk.vue';
import { GetCourseById, SaveCourse, UpdateCourse } from '@/api/course';
import { Category } from '@/utils/utils';
import Utils from '@/assets/js/Utils';
export default {
    props: ['disabled'],
    components: { UploadChunk },
    data() {
        return {
            Category,
            aiVideoName: '',
            form: {
                "classifyCode": "CIS",
                "classifyName": "智能建造",
                "convertRule": 0,
                "courseCode": "",
                "courseDescription": "",
                "courseDesign": "",
                "courseFeature": "",
                "courseName": "",
                "courseTarget": "",
                "coverImageUrl": "",
                "credit": 0,
                "creditHour": 0,
                "id": "",
                "introduceVideoFileId": "",
                "referenceStandard": ""
            }
        }
    },
    computed: {
        courseId() {
            return this.$store.state.course.currentCourseId || this.$route.query.id || '';
        }
    },
    mounted() {
        this.courseByDetailId();
        Utils.$on('ai_create_course', this.useAiMonitor)
    },
    destroyed() {
        Utils.$off('ai_create_course',this.useAiMonitor);
    },

    methods: {
        /**ai引用监听 */
        useAiMonitor(data) {
            const setCourse = () => {
                if (this.courseId) {
                    this.updateCourse();
                } else {
                    this.addCourse();
                };
            }
            for (let key in data) {
                if (key == 'videoName') {
                    this.aiVideoName = data[key];
                    continue;
                } else if (key == 'coverImageUrl') {
                    const img = new Image();
                    img.onload = () => {
                        this.form.coverImageUrl = data.coverImageUrl.replace(/\n+$/, '');
                        setCourse();
                    }; // 加载成功
                    img.onerror = () => {
                        this.form.coverImageUrl = ''
                        setCourse();
                    }; // 加载失败
                    img.src = data[key];
                    continue;
                }
                this.form[key] = (data[key] ? data[key].replace(/\n+$/, '') : '');
            }
            this.form.convertRule = 1;
            if (this.form.introduceVideoFileId) {
                var data1 = {
                    fileName: this.aiVideoName,
                    status: 'success',
                }
                this.backShowVideo([data1]);
            } else {
                let chunk = this.$refs.chunk;
                if (chunk) {
                    chunk.fileArr = [];
                }
            }
        },
        /**获取图片地址 */
        getImgUrl(url) {
            if (url.includes('://whzdzx.zdzxtech.cn')) {
                return url;
            } else {
                return this.$severUrl(url);
            }
        },
        /**切换所属分类 */
        changeCode(e) {
            let el = Category.find(item => item.value == e);
            if (el) {
                this.form.classifyName = el.label;
            }
            this.save();
        },
        /**新增课程 */
        addCourse() {
            if (!this.form.courseName) return;
            SaveCourse(this.form).then(res => {
                if (res.code == 200) {
                    this.$store.commit('course/changeClassifyCode', this.form.classifyCode);
                    this.$store.commit('course/changeId', res.data);
                    this.$emit('save_success');
                }
            })
        },
        /**修改课程 */
        updateCourse() {
            console.log(this.form, 'zzz')
            if (!this.form.courseName) return;
            this.form.id = this.courseId;
            UpdateCourse(this.form).then(res => {
                if (res.code == 200) {
                    this.$emit('save_success');
                }
            })
        },
        /**保存基本信息 */
        save() {
            if (!this.courseId) {
                this.addCourse();
            } else {
                this.updateCourse();
            }
        },
        /**课程基本信息详情查询 */
        courseByDetailId() {
            if (this.courseId) {
                GetCourseById({ id: this.courseId }).then(res => {
                    if (res.code == 200) {
                        this.form = res.data;
                        this.$store.commit('course/changeClassifyCode', this.form.classifyCode);
                        if (res.data.introduceVideoFileId) {
                            var data = {
                                fileName: res.data.introduceVideoName,
                                status: 'success',
                            }
                            this.backShowVideo([data]);
                        }
                    }
                })
            }
        },
        /**回显视频上传 */
        backShowVideo(data) {
            var chunk = this.$refs.chunk;
            if (chunk) {
                chunk.fileArr = data;
            }
        },
        /**上传视频 */
        upload(e) {
            if (e.length == 0) {
                this.form.introduceVideoFileId = '';
            } else {
                this.form.introduceVideoFileId = e[0].id;
            }
            this.save();
        },
        /**上传封面 */
        handleFm(e) {
            uploadFile(e.raw).then(res => {
                if (res) {
                    this.form.coverImageUrl = res.previewUrl;
                    this.save();
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.course-title {
    margin-bottom: 2rem;
    color: #334681;
    font-size: 12px;
}

/deep/.el-textarea__inner {
    height: 8rem;
}

.user-box {
    width: 3.2rem;
    height: 3.2rem;
    border: 1px solid #e8ecef;
    border-radius: 6px;
    text-align: center;
    line-height: 3.2rem;
    color: #8590B3;
}

.upload-box-img {
    /deep/.el-upload {
        width: 6rem;
        height: 6rem;
        position: relative;
    }

    /deep/.el-upload--picture-card {
        border: 1px solid #e8ecef;
        background: #ffffff;
    }

    /deep/.el-icon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1rem;
    }
}

.chunk-box {
    height: 14rem;
    width: 100%;
}

.tip {
    color: #8590B3;
    font-size: 12px;
}

.base-box {
    border-radius: 10px;
}

.content-box {
    min-height: 70rem;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    box-shadow: 0px 0px 15px 0px rgba(231, 236, 239, 0.10);
    margin-top: 3rem;
    padding: 3rem;
}

.first-line {
    display: flex;
    align-items: center;

    i {
        color: #387DFF;
        font-size: 2rem;
        cursor: pointer;
    }

    &> :nth-child(2) {
        font-size: 16px;
        color: #334681;
        margin-left: 1rem;
    }
}

.second-line {
    display: flex;
    align-items: center;
    padding: 3rem 0;
    border-bottom: 1px solid #EAEBF0;
}

.third-line {
    padding: 2rem 0;
    display: flex;
    align-items: center;

    &> :nth-child(2) {
        margin-right: 3rem;
    }
}

.save-box {
    padding: 3rem;
    text-align: center;
}
</style>